import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<Date> {
    fromModel(date: Date | null): NgbDateStruct | null {
        if (date) {
            return {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear(),
            };
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): Date | null {
        return date ? new Date(date.year, date.month - 1, date.day) : null;
    }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    readonly DELIMITER = '/';

    parse(value: string): NgbDateStruct | null {
        if (value) {
            const date = new Date(value);
            return {
                day: date.getDate(),
                month: date.getMonth(),
                year: date.getFullYear(),
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date
            ? ('0' + date.day).slice(-2) +
                  this.DELIMITER +
                  ('0' + date.month).slice(-2) +
                  this.DELIMITER +
                  date.year
            : '';
    }
}
